document.addEventListener( 'DOMContentLoaded', function () {
	const SPLIDE_CDN_URL =
		'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';

	function loadScript( src ) {
		return new Promise( ( resolve, reject ) => {
			const script = document.createElement( 'script' );
			script.src = src;
			script.onload = resolve;
			script.onerror = () => reject( new Error( `Failed to load script: ${ src }` ) );
			document.head.appendChild( script );
		} );
	}

	const defaultConfig = {
		type: 'loop',
		fixedWidth: 200,
		fixedHeight: 300,
		perMove: 1,
		speed: 500,
		gap: '8px',
		draggable: true,
		wheel: false,
		breakpoints: {
			768: {
				perPage: 4,
				gap: '8px',
			},
			575: {
				perPage: 4,
				gap: '8px',
			},
		},
	};

	const elements = document.querySelectorAll( '.top-hundred-container' );
	if ( elements.length ) {
		loadScript( SPLIDE_CDN_URL )
			.then( () => {
				elements.forEach( el => {
					const slideCount = el.querySelectorAll( '.splide__slide' ).length;
					const config = {
						...defaultConfig,
						arrows: slideCount > 1,
						pagination: slideCount > 1,
						drag: slideCount > 1,
					};
					new Splide( el, config ).mount();
				} );
			} )
			.catch( error => {
				console.error( 'Failed to load Splide library:', error );
			} );
	}
} );
